var map = {
	"./add-patient.png": "e693",
	"./add-user.png": "7e4d",
	"./assign-node.png": "4dc0",
	"./change-product.png": "2fed",
	"./reassign-pod.png": "1266",
	"./remove-or-archive-patient.png": "b912",
	"./update-patient.png": "da9d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dabb";